import {NotificationService} from "../../services/NotificationService";
import {ServerStatusService} from "../../services/ServerStatusService";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {ApplicationSetting} from "../../entities/ApplicationSetting";
import { ClientApp } from "../../entities/ClientApp";
import { Location } from '../../entities/Location';
import {ClientAppService} from "../../services/ClientAppService";
import {MaintenanceHistory} from "../../entities/MaintenanceHistory";
import { CompanyService } from "../../services/CompanyService";
import { Company } from "../../entities/Company";
import { MqttClient } from "../../entities/MqttClient";
import { MqttClientService } from "../../services/MqttClientService";
import { PrintClient } from "../../entities/PrintClient";
import { PrintClientService } from "../../services/PrintClientService";
import { LocationService } from "../../services/LocationService";

export class EditOptionsModel {
    static $inject = ['$q','LocationService','ApplicationSettingService', 'ClientAppService','MqttClientService','PrintClientService','CompanyService','ServerStatusService','NotificationService'];
    applicationsetting:ApplicationSetting;
    selectedClientApp: ClientApp;
    selectedMqttClient: MqttClient;
    selectedPrintClient: PrintClient;
    selectedCompany: Company;
    clientApps: ClientApp[];
    locations: Location[];
    mqttClients: MqttClient[];
    printClients: PrintClient[];
    companies: Company[];
    temperatureFormats:string[] = ["Fahrenheit", "Celsius"];
    emailOptions:string[] = ["Cloud", "SMTP"];
    alarmUnassociatedOptions:boolean[] = [true,false];
    vTagGpsServerConnected:boolean = false;
    errorMessage:string = "";
    constructor(public $q: ng.IQService,
                public locationService: LocationService,
                public applicationSettingService:ApplicationSettingService,
                public clientAppService: ClientAppService,
                public mqttClientService: MqttClientService,
                public printClientService: PrintClientService,
                public companyService: CompanyService,
                public serverStatusService:ServerStatusService,
                public notifyService:NotificationService) {
    }
    loadData():ng.IPromise<boolean>{
        var serverStatusPromise = this.serverStatusService.chirpstackConnected();
        var appSettingServicePromise = this.applicationSettingService.getCached(true);
        var clientAppPromise = this.clientAppService.getAll();
        var mqttClientPromise = this.mqttClientService.getAll();
        var printClientPromise = this.printClientService.getAll();
        var locationPromise = this.locationService.getAll();
        var companyPromise = this.companyService.getAll();
        return this.$q.all([serverStatusPromise, appSettingServicePromise, clientAppPromise, mqttClientPromise, printClientPromise, companyPromise, locationPromise]).then((data) => {
            this.vTagGpsServerConnected = data[0];
            this.applicationsetting = data[1];
            this.clientApps = data[2];
            this.mqttClients = data[3];
            this.printClients = data[4];
            this.companies = data[5];
            var emptyLocation = new Location();
            emptyLocation.id = null;
            emptyLocation.name = "";
            var newLocations = [emptyLocation];
            for (var i = 0; i<data[6].length; i++)
                newLocations.push(data[6][i]);
            this.locations = newLocations;
            return this.$q.when(true);
        });
    }
    addClientApp(item: ClientApp): ng.IPromise<number> {
        return this.clientAppService.insert(item);
    }
    editClientApp(item: ClientApp): ng.IPromise<boolean> {
        return this.clientAppService.update(item);
    }
    deleteClientApp(item: ClientApp): ng.IPromise<boolean> {
        return this.clientAppService.delete([item.id]);
    }
    addMqttClient(item: MqttClient): ng.IPromise<number> {
        return this.mqttClientService.insert(item);
    }
    editMqttClient(item: MqttClient): ng.IPromise<boolean> {
        return this.mqttClientService.update(item);
    }
    deleteMqttClient(item: MqttClient): ng.IPromise<boolean> {
        return this.mqttClientService.delete([item.id]);
    }
    addPrintClient(item: PrintClient): ng.IPromise<number> {
        return this.printClientService.insert(item);
    }
    editPrintClient(item: PrintClient): ng.IPromise<boolean> {
        return this.printClientService.update(item);
    }
    deletePrintClient(item: PrintClient): ng.IPromise<boolean> {
        return this.printClientService.delete([item.id]);
    }
    addCompany(item: Company): ng.IPromise<number> {
        return this.companyService.insert(item);
    }
    editCompany(item: Company): ng.IPromise<boolean> {
        return this.companyService.update(item);
    }
    deleteCompany(item: Company): ng.IPromise<boolean> {
        return this.companyService.delete([item.id]);
    }
    save(){
        this.applicationSettingService.update(this.applicationsetting).then(()=>{
            this.notifyService.notify("Edit Options Updated Successfully. Please log out to see new changes.");
        })
        .catch((exc)=>{
            this.notifyService.notify("Update Exception:"+exc);
        });
    }
    testGpsConnection(){
      this.applicationSettingService.testChirpstack(this.applicationsetting.vTagGpsServerAddress, this.applicationsetting.vTagGpsServerUsername, this.applicationsetting.vTagGpsServerPassword).then((ok)=>{
          if(ok)
            this.notifyService.notify("Server Connection Succeeded.");
          else
              this.notifyService.notify("Server Connection Failed.");
      })
      .catch((exc)=>{
          this.notifyService.notify("Server Test Connection Exception:"+exc);
      });
    }
    testEmail() {
        if (this.applicationsetting.emailMethod == "Cloud") {
            this.applicationSettingService.testCloudEmail(this.applicationsetting.smtpEmailTo,
                this.applicationsetting.emailCloudUsername,
                this.applicationsetting.emailCloudPassword).then((ok) => {
                    if(ok)
                        this.notifyService.notify("Email Sent. Check your inbox.");
                    else
                        this.notifyService.notify("Email was not sent successfully. Check web server for logs.");
                })
                .catch((exc) => {
                    this.notifyService.notify("Server Test Connection Exception:" + exc);
                });
        }
        else {
            this.applicationSettingService.testSmtpEmail(this.applicationsetting.smtpEmailHost,
                this.applicationsetting.smtpEmailPort,
                this.applicationsetting.smtpEmailUsername,
                this.applicationsetting.smtpEmailPassword,
                this.applicationsetting.smtpEmailTo,
                this.applicationsetting.smtpEmailEnableSSL).then((ok) => {
                    if(ok)
                        this.notifyService.notify("Email Sent. Check your inbox.");
                    else
                        this.notifyService.notify("Email was not sent successfully. Check web server for logs.");
                })
                .catch((exc) => {
                    this.notifyService.notify("Server Test Connection Exception:" + exc);
                });
        }        
    }
}
